import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Roles } from '../Redux/reducers/roles';
import { getRoles } from '../Services/API';

export function useFetchRoles(queries = [], skip = 0, limit = 10) {
  const { roles, loading, error } = useSelector((state) => state.roles);
  const dispatch = useDispatch();
  const [params, setParams] = useState({ queries, skip, limit });
  useEffect(() => {
    if (roles.data.length === 0) {
      dispatch(Roles.rolesRequest());
      getRoles(params.queries, params.skip, params.limit).then((response) => {
        if (response.ok) {
          dispatch(Roles.rolesSuccess(response.data));
        } else {
          dispatch(Roles.rolesFailure(response.data));
        }
      });
    }
  }, [params, dispatch, roles.data]);
  function onChangeParams(q = [], s = 0, l = 10) {
    setParams({ queries: q, skip: s, limit: l });
  }
  async function update() {
    dispatch(Roles.rolesRequest());
    getRoles(params.queries, params.skip, params.limit).then((response) => {
      if (response.ok) {
        dispatch(Roles.rolesSuccess(response.data));
      } else {
        dispatch(Roles.rolesFailure(response.data));
      }
    });
  }
  return [roles.data, loading, error, onChangeParams, update];
}

export function useFetchRolesM(queries = [], skip = 0, limit = 10) {
  //No redux
  const [loading, setLoading] = useState(true);
  const [params, setParams] = useState({ queries, skip, limit });
  const [error, setError] = useState(null);
  const [data, setData] = useState({ total: 0, data: [], skip: 0 });
  useEffect(() => {
    setLoading(true);
    getRoles(params.queries, params.skip, params.limit).then((response) => {
      if (response.ok) {
        setData(response.data);
      } else {
        setError(response.data);
      }
      setLoading(false);
    });
  }, [params, setData, setError, setLoading]);
  function onChangeParams(q = [], s = 0, l = 10) {
    setParams({ queries: q, skip: s, limit: l });
  }
  async function update() {
    setLoading(true);
    let response = await getRoles(params.queries, params.skip, params.limit);
    if (response.ok) {
      setData(response.data);
    } else {
      setError(response.data);
    }
    setLoading(false);
  }
  return [data.data, loading, error, onChangeParams, update];
}
